import { render } from "./DamageDetail.vue?vue&type=template&id=49718792&scoped=true"
import script from "./DamageDetail.vue?vue&type=script&lang=js"
export * from "./DamageDetail.vue?vue&type=script&lang=js"

import "./DamageDetail.vue?vue&type=style&index=0&id=49718792&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49718792"]])

export default __exports__